const BaseUrlScreenBackground = () => (
	<svg viewBox="0 36 260 544" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M0 0H260V210H0V0Z" fill="#D6D9FC" />
		<path d="M0 210H260V544H0V210Z" fill="white" />
		<g filter="url(#filter0_d_11663_35880)">
			<rect
				x="20"
				y="86"
				width="220"
				height="218"
				rx="6"
				fill="white"
				shapeRendering="crispEdges"
			/>
			<path
				d="M28 100C28 96.6863 30.6863 94 34 94H226C229.314 94 232 96.6863 232 100V238C232 241.314 229.314 244 226 244H34C30.6863 244 28 241.314 28 238V100Z"
				fill="#CDD0DB"
				fillOpacity="0.5"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M117.917 155.667H142.084C144.609 155.667 146.667 157.725 146.667 160.25V177.75C146.667 180.275 144.609 182.333 142.084 182.333H117.917C115.392 182.333 113.334 180.275 113.334 177.75V160.25C113.334 157.725 115.392 155.667 117.917 155.667ZM117.917 158.167C116.767 158.167 115.834 159.1 115.834 160.25V177.758C115.834 178.517 116.242 179.175 116.859 179.542L125.609 170.792C126.426 169.983 127.751 169.983 128.559 170.792L130.834 173.067L137.692 166.208C138.509 165.4 139.834 165.4 140.642 166.208L144.167 169.733V160.25C144.167 159.1 143.234 158.167 142.084 158.167H117.917ZM120.101 179.833H142.084C143.234 179.833 144.167 178.9 144.167 177.75V173.267L139.167 168.267L130.834 176.6L127.084 172.85L120.101 179.833ZM126.667 164.833C126.667 167.133 124.801 169 122.501 169C120.201 169 118.334 167.133 118.334 164.833C118.334 162.533 120.201 160.667 122.501 160.667C124.801 160.667 126.667 162.533 126.667 164.833ZM124.167 164.833C124.167 163.917 123.417 163.167 122.501 163.167C121.584 163.167 120.834 163.917 120.834 164.833C120.834 165.75 121.584 166.5 122.501 166.5C123.417 166.5 124.167 165.75 124.167 164.833Z"
				fill="white"
			/>
			<path
				d="M28 260C28 257.791 29.7909 256 32 256H228C230.209 256 232 257.791 232 260C232 262.209 230.209 264 228 264H32C29.7909 264 28 262.209 28 260Z"
				fill="#CDD0DB"
				fillOpacity="0.5"
			/>
			<path
				d="M28 276C28 273.791 29.7909 272 32 272H228C230.209 272 232 273.791 232 276C232 278.209 230.209 280 228 280H32C29.7909 280 28 278.209 28 276Z"
				fill="#CDD0DB"
				fillOpacity="0.5"
			/>
			<path
				d="M80 292C80 289.791 81.7909 288 84 288H176C178.209 288 180 289.791 180 292C180 294.209 178.209 296 176 296H84C81.7909 296 80 294.209 80 292Z"
				fill="#CDD0DB"
				fillOpacity="0.5"
			/>
		</g>
		<g filter="url(#filter1_d_11663_35880)">
			<rect
				x="20"
				y="320"
				width="220"
				height="56"
				rx="6"
				fill="white"
				shapeRendering="crispEdges"
			/>
			<path
				d="M28 348C28 336.954 36.9543 328 48 328C59.0457 328 68 336.954 68 348C68 359.046 59.0457 368 48 368C36.9543 368 28 359.046 28 348Z"
				fill="#CDD0DB"
				fillOpacity="0.5"
			/>
			<path
				d="M80 334C80 332.343 81.3431 331 83 331H229C230.657 331 232 332.343 232 334C232 335.657 230.657 337 229 337H83C81.3431 337 80 335.657 80 334Z"
				fill="#CDD0DB"
				fillOpacity="0.5"
			/>
			<path
				d="M80 348C80 346.343 81.3431 345 83 345H229C230.657 345 232 346.343 232 348C232 349.657 230.657 351 229 351H83C81.3431 351 80 349.657 80 348Z"
				fill="#CDD0DB"
				fillOpacity="0.5"
			/>
			<path
				d="M80 362C80 360.343 81.3431 359 83 359H177C178.657 359 180 360.343 180 362C180 363.657 178.657 365 177 365H83C81.3431 365 80 363.657 80 362Z"
				fill="#CDD0DB"
				fillOpacity="0.5"
			/>
		</g>
		<g filter="url(#filter2_d_11663_35880)">
			<rect
				x="20"
				y="392"
				width="220"
				height="56"
				rx="6"
				fill="white"
				shapeRendering="crispEdges"
			/>
			<path
				d="M28 420C28 408.954 36.9543 400 48 400C59.0457 400 68 408.954 68 420C68 431.046 59.0457 440 48 440C36.9543 440 28 431.046 28 420Z"
				fill="#CDD0DB"
				fillOpacity="0.5"
			/>
			<path
				d="M80 406C80 404.343 81.3431 403 83 403H229C230.657 403 232 404.343 232 406C232 407.657 230.657 409 229 409H83C81.3431 409 80 407.657 80 406Z"
				fill="#CDD0DB"
				fillOpacity="0.5"
			/>
			<path
				d="M80 420C80 418.343 81.3431 417 83 417H229C230.657 417 232 418.343 232 420C232 421.657 230.657 423 229 423H83C81.3431 423 80 421.657 80 420Z"
				fill="#CDD0DB"
				fillOpacity="0.5"
			/>
			<path
				d="M80 434C80 432.343 81.3431 431 83 431H177C178.657 431 180 432.343 180 434C180 435.657 178.657 437 177 437H83C81.3431 437 80 435.657 80 434Z"
				fill="#CDD0DB"
				fillOpacity="0.5"
			/>
		</g>
		<defs>
			<filter
				id="filter0_d_11663_35880"
				x="12"
				y="79"
				width="236"
				height="234"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.24705 0 0 0 0 0.281923 0 0 0 0 0.405566 0 0 0 0.16 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_11663_35880"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_11663_35880"
					result="shape"
				/>
			</filter>
			<filter
				id="filter1_d_11663_35880"
				x="12"
				y="313"
				width="236"
				height="72"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.24705 0 0 0 0 0.281923 0 0 0 0 0.405566 0 0 0 0.16 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_11663_35880"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_11663_35880"
					result="shape"
				/>
			</filter>
			<filter
				id="filter2_d_11663_35880"
				x="12"
				y="385"
				width="236"
				height="72"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.24705 0 0 0 0 0.281923 0 0 0 0 0.405566 0 0 0 0.16 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_11663_35880"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_11663_35880"
					result="shape"
				/>
			</filter>
		</defs>
		<path
			xmlns="http://www.w3.org/2000/svg"
			d="M20 470C20 466.686 22.6863 464 26 464H234C237.314 464 240 466.686 240 470V498C240 501.314 237.314 504 234 504H26C22.6863 504 20 501.314 20 498V470Z"
			fill="#9BA2FB"
		/>
		<path
			opacity="0.3"
			d="M90 483C90 481.343 91.3431 480 93 480H167C168.657 480 170 481.343 170 483C170 484.657 168.657 486 167 486H93C91.3431 486 90 484.657 90 483Z"
			fill="white"
		/>
	</svg>
)
export { BaseUrlScreenBackground }
